'use client';

import React, { useEffect, useRef } from 'react';
import './slider.css';
import { cn } from '@/lib/utils';
import { TabBanner } from '@/types/homepage/homepageTypes';
import useColorContrast from '@/hooks/useColorContrast';
import { getThemeClass } from '@/helpers/theme';

interface SliderWithTabsProps {
  children: React.ReactNode;
  slides: TabBanner[];
  heading: string;
  slideTo?: any;
  activeTab?: any;
  isMobile: boolean;
}

const SliderWithTabs: React.FC<SliderWithTabsProps> = ({
  children,
  slides,
  heading,
  slideTo,
  activeTab,
  isMobile,
}) => {
  const tabsContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tabsContainerRef.current && slides.length > 1) {
      const containerWidth = tabsContainerRef.current.offsetWidth;
      const activeTabElement = tabsContainerRef.current.children[
        activeTab
      ] as HTMLElement; // Type assertion
      if (activeTabElement) {
        const activeTabWidth = activeTabElement.offsetWidth;
        const activeTabLeft = activeTabElement.offsetLeft;
        const activeTabCenter = activeTabLeft + activeTabWidth / 2;
        const scrollLeft = activeTabCenter - containerWidth / 2;
        tabsContainerRef.current.scrollTo({
          left: scrollLeft,
          behavior: 'smooth',
        });
      }
    }
  }, [activeTab, slides]);

  // const isLight = useColorContrast(
  //   slides[activeTab]?.tab_banner_id?.bg_color ?? '#fff'
  // );

  const theme = slides[activeTab]?.theme || 'dark';

  return (
    <div className={cn(`mx-auto mt-5 md:mt-10`)}>
      <div
        className={`absolute z-10 left-0 right-0 flex  flex-col gap-5 md:gap-8`}
      >
        <h2
          className={`font-bold text-center text-2xl leading-[32px] md:text-[32px] md:leading-[48px] z-20 px-4 ${getThemeClass(theme, 'heading')}`}
        >
          {heading}
        </h2>

        <div
          ref={tabsContainerRef}
          className="flex gap-6 md:gap-10 lg:gap-14 mb-4 w-full overflow-x-auto no-scroll px-4"
        >
          {slides.length > 1 &&
            slides.map((item, index) => {
              return (
                <div
                  key={index}
                  className={cn(
                    'py-2 cursor-pointer font-semibold text-[16px] font-proxima_font opacity-50 whitespace-nowrap relative first:ml-auto last:mr-auto',
                    activeTab === index && 'link opacity-100 ',
                    getThemeClass(theme, 'heading')
                  )}
                  onClick={() => slideTo(index)}
                >
                  {item?.tab_title}
                </div>
              );
            })}
        </div>
      </div>

      <div className="!absolute top-0 bottom-0 w-full slideComponentWrapper">
        {children}
      </div>
      <div
        // ref={tabsContainerRef}
        className="flex md:hidden absolute bottom-0 z-10 space-x-3 mb-4 w-full overflow-x-auto no-scroll px-4"
      >
        {slides.length > 1 &&
          slides.map((item, index) => {
            return (
              <div
                key={index}
                className={cn(
                  'py-2 cursor-pointer font-semibold text-sm md:text-base whitespace-nowrap relative z-10 first:!ml-auto last:!mr-auto '
                )}
                onClick={() => slideTo(index)}
              >
                <div
                  className={`w-2 h-2 rounded-full ${activeTab === index ? 'opacity-100' : 'opacity-50'} bg-white`}
                ></div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SliderWithTabs;
